// ADMIN, CASHIER, DIRECTOR, MODERATOR, SELLER, USER
const roles = [
  {
    en: "ADMIN",
    uz: "Admin",
  },
  {
    en: "PHOTO_ADMIN",
    uz: "Foto Admin",
  },
  {
    en: "CASHIER",
    uz: "Kassir",
  },
  {
    en: "DIRECTOR",
    uz: "Direktor",
  },
  {
    en: "MODERATOR",
    uz: "Moderator",
  },
  {
    en: "SELLER",
    uz: "Sotuvchi",
  },
  {
    en: "MANAGER",
    uz: "Menejer",
  },
  {
    en: "CLIENT",
    uz: "Klient",
  },
  {
    en: "USER",
    uz: "Foydalanuvchi",
  },
];

export default roles;
